import { SvgIcon, SvgIconProps } from "@mui/material";

export const Whatsapp = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_23_45)">
        <path
          d="M13.5034 0H13.4966C6.05306 0 0 6.05475 0 13.5C0 16.4531 0.95175 19.1903 2.57006 21.4127L0.887625 26.4279L6.07669 24.7691C8.21138 26.1833 10.7578 27 13.5034 27C20.9469 27 27 20.9436 27 13.5C27 6.05644 20.9469 0 13.5034 0ZM21.3587 19.0637C21.033 19.9834 19.7404 20.7461 18.7093 20.9689C18.0039 21.1191 17.0826 21.2389 13.9809 19.953C10.0136 18.3094 7.45875 14.2779 7.25962 14.0164C7.06894 13.7548 5.6565 11.8817 5.6565 9.94444C5.6565 8.00719 6.64031 7.06388 7.03688 6.65887C7.36256 6.32644 7.90088 6.17456 8.41725 6.17456C8.58431 6.17456 8.7345 6.183 8.8695 6.18975C9.26606 6.20662 9.46519 6.23025 9.72675 6.85631C10.0524 7.641 10.8456 9.57825 10.9401 9.77738C11.0363 9.9765 11.1324 10.2465 10.9974 10.5081C10.8709 10.7781 10.7595 10.8979 10.5604 11.1274C10.3612 11.3569 10.1722 11.5324 9.97312 11.7788C9.79087 11.9931 9.585 12.2226 9.8145 12.6191C10.044 13.0072 10.8371 14.3016 12.0049 15.3411C13.5118 16.6826 14.7336 17.1112 15.1706 17.2935C15.4963 17.4285 15.8844 17.3964 16.1224 17.1433C16.4244 16.8176 16.7974 16.2776 17.1771 15.7461C17.4471 15.3647 17.7879 15.3174 18.1457 15.4524C18.5102 15.579 20.439 16.5324 20.8356 16.7299C21.2321 16.929 21.4937 17.0235 21.5899 17.1906C21.6844 17.3576 21.6844 18.1423 21.3587 19.0637Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_23_45">
          <rect width="27" height="27" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
